/**
 * Phone type enumeration
 */
export enum PhoneType {
  Cell = "CELL",
  Home = "HOME",
  Work = "WORK",
  Hrs_24 = "HRS_24",
  Emergency = "EMERGENCY",
  Fax = "FAX",
}

/**
 * Phone type with number
 */
export type Phone = {
  type: PhoneType;
  number?: string | null;
};
